import axios from 'axios'
import modals from '~/lib/modals'

export default {
  mixins: [modals],
  data () {
    return {
      brioxPaymentMethods: []
    }
  },
  computed: {
    isBrioxEnabled () {
      return this.settings && parseInt(this.settings.pay_option20)
    },
    isBrioxConfigured () {
      return this.settings &&
        this.settings.briox_accountid !== null &&
        this.settings.briox_accountid !== undefined &&
        String(this.settings.briox_accountid).trim() !== '' &&
        this.settings.briox_apptoken !== null &&
        this.settings.briox_apptoken !== undefined &&
        String(this.settings.briox_apptoken).trim() !== ''
    }
  },
  methods: {
    loadBrioxPaymentMethods () {
      return new Promise(async (resolve) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/brioxpaymentmethods.json?apikey=' + this.apiKey)
        } catch (e) {
          this.showError(e)
          resolve([])
          return
        }
        this.brioxPaymentMethods = response.data
        resolve(response.data)
      })
    },
    brioxPaymentMethodTitle (id) {
      if (!parseInt(id)) {
        return ''
      }
      const method = this.brioxPaymentMethods.find(m => parseInt(m.id, 10) === parseInt(id, 10))
      if (method) {
        return id + ' ' + method.name
      }
      return id
    },
    async brioxPaymentMethodDialog (obj, field) {
      const methods = await this.loadBrioxPaymentMethods()
      this.showDialog({
        title: this._('Briox payment method'),
        buttons: [
          {
            title: this._('Close'),
            icon: 'close',
            handler: () => {}
          },
          {
            title: this._('Ok'),
            class: 'success',
            icon: 'check',
            handler: (data) => {
              obj[field] = data.paymentmethod
            }
          }
        ],
        fields: [
          {
            title: this._('Payment method'),
            type: 'select',
            name: 'paymentmethod',
            options: methods.map(m => { return { value: m.id, name: m.name } }),
            defaultValue: parseInt(obj[field]) ? obj[field] : null
          }
        ]
      })
    },
    async brioxSync () {
      const payload = { brioxsync: 1 }
      let response
      try {
        response = await axios.put(this.baseDomain + this.shopId + '/settings/1.json?apikey=' + this.apiKey, payload)
      } catch (e) {
        this.showError(e)
        return
      }
      this.showNotification(this._('Synchronization scheduled. It should be complete in a few minutes.'))
    }
  }
}
